(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    function initSwatches() {
      document.querySelectorAll('.product-card__swatch').forEach(btn => {
        btn.addEventListener('mouseenter', () => {
          const imageUrl = btn.dataset.imageUrl;
          if (!imageUrl) return;
          const cardId = btn.dataset.cardId;
          const card = document.getElementById(cardId);
          if (!card) return;

          // Alle möglichen Bild-Elemente ansprechen
          const targets = card.querySelectorAll('img, [style*="background-image"]');
          targets.forEach(el => {
            if (el.closest('.product-card__swatches')) return;
            if (el.tagName === 'IMG') {
              el.setAttribute('src', imageUrl);
              el.removeAttribute('srcset');
              el.removeAttribute('data-srcset');
            } else {
              el.style.backgroundImage = `url(${imageUrl})`;
            }
          });

          // Für Shopify lazy-image Web Components
          const lazyImgs = card.querySelectorAll('lazy-image, deferred-media');
          lazyImgs.forEach(el => {
            const img = el.querySelector('img');
            if (img) {
              img.setAttribute('src', imageUrl);
              img.removeAttribute('srcset');
            }
          });
        });
      });
    }

    // Auch nach dynamischen Renders neu initialisieren
    document.addEventListener('DOMContentLoaded', initSwatches);
    setTimeout(initSwatches, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
